import axiosBase from 'axios';
import { API_URL } from '../config';

const axios = axiosBase.create({
  baseURL: API_URL,
});

export const search = query => axios.get('/search', { params: { q: query } });

export const getMoreResults = url => axios.get(url);

export const getFolders = folderId => axios.get('/folders', { params: { folderId } });
